import { ServiceDetailsFormBody } from './ServiceDetailsFormBody/ServiceDetailsFormBody';

export function ServiceDetailsFormSection() {
  return (
    <div className="flex flex-col gap-y-2">
      <ServiceDetailsFormBody />
    </div>
  );
}
